/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/

export class DetailRequest {


   public vendorId: number;


    constructor(detailRequest: any) {
        this.vendorId = detailRequest.id || '';
    }
}
